/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { fontFamily, colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

const DiffInformationBanner = styled.span`
  width: 100%;
  position: sticky;
  font-family: ${fontFamily()};
  top: 96px;
  z-index: 100;
  display: inline-block;
  text-align: center;
  flex-direction: column;
  background-color: ${token('color.background.brand.boldest', colors.N700)};
  color: ${token('color.text.inverse', colors.N0)};

  button {
    cursor: pointer;
    outline: none;
    color: ${token('color.text.inverse', colors.N0)};
    text-decoration: underline;
    background: transparent;
  }
`;

export default DiffInformationBanner;
